

/**
	* @ngdoc service
	* @name app.$isDev
	* @description
	* # $isDev
	* Provider in the app.
	*/
angular.module('app')
	.factory('$isDev', /* @ngInject */ function ($location) {
		return $location.host() === 'localhost';
	});
